import React from 'react';
import { Box } from '@mui/material';

/**
 * Renders a visually-hidden "Skip to main content" link that becomes visible
 * on keyboard focus.  Allows keyboard / screen-reader users to bypass the
 * navigation sidebar and app-bar and jump straight to the page content.
 *
 * The target element must have `id="main-content"` and `tabIndex={-1}`.
 */
export const SkipNavigation: React.FC = () => (
  <Box
    component="a"
    href="#main-content"
    sx={{
      position: 'absolute',
      left: '-9999px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      zIndex: (theme) => theme.zIndex.tooltip + 1,
      '&:focus': {
        position: 'fixed',
        top: 8,
        left: 8,
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        padding: '12px 24px',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        fontWeight: 700,
        fontSize: '0.875rem',
        borderRadius: 1,
        textDecoration: 'none',
        boxShadow: 4,
        outline: '2px solid',
        outlineColor: 'secondary.main',
        outlineOffset: 2,
      },
    }}
  >
    Skip to main content
  </Box>
);
